import React from 'react';
import './main-footer.scss';
import {Link, useLocation} from 'react-router-dom';
import {FormattedMessage} from 'react-intl';
import classNames from 'classnames';
import searchFilter from '../../searchFilter';
import useQuery from '../../useQuery';
import IconMaster from '../../assets/icons-payment/icon-master.svg';
import IconVisa from '../../assets/icons-payment/icon-visa.svg';
import IconApplePay from '../../assets/icons-payment/icon-apple-pay.svg';
import IconGooglePay from '../../assets/icons-payment/icon-google-pay.svg';
import LogoDarkModeFalseSvg from '../../assets/logo-dark-mode-false.svg';
import Skeleton from '../../components/Skeleton';
import getLocaleQueryParams from '../../utilities/get-locale-query-params';
import Feedback from '../feedback/feedback';
import Button from '../button/button';

const year = new Date().getFullYear();

const Footer = () => {
    const location = useLocation();
    const {locale = 'uk'} = useQuery();
    return (
        <div className='view'>
            <div className='block'>
                <div className='padding-top-3rem padding-bottom-3rem'>
                    <React.Suspense fallback={<Skeleton/>}>
                        <div className='display-flex justify-content-space-between align-items-center'>
                            {/*<img src='/assets/logo-dark-mode-false.png'/>*/}
                            {/*<img src={LogoDarkModeFalseSvg} alt=''/>*/}
                            <Link to={`/${searchFilter(location.search)}`}>
                                <LogoDarkModeFalseSvg className='display-block'/>
                            </Link>
                            <div className='hide-small'>
                                <Feedback>
                                    <Button {...{color: 'primary-gradient', size: 'sm', clickHandler: () => {}}}>
                                        <FormattedMessage defaultMessage='Leave feedback'/>
                                    </Button>
                                </Feedback>
                            </div>
                        </div>
                        <div className='padding-top-1dot5rem mw768-padding-top-2rem display-flex flex-direction-column-row justify-content-space-between padding-bottom-2rem'>
                            <div className='text-md color-gray-500'>
                                <div className='display-block-inline'><FormattedMessage defaultMessage='Ottry LLC'/></div>
                                <div className='hide-small display-block-inline'>,{' '}</div>
                                <div className='display-block-inline'><FormattedMessage defaultMessage='VAT identification number is 41385243'/></div>
                                <div className='display-block'><FormattedMessage defaultMessage='16, Hlybochytska Street, office 13, Kyiv, 04050'/></div>
                            </div>
                            <div className='margin-top-1dot5rem mw768-margin-top-0'>
                                <a href='tel:+380979381162'>
                                    <div className='text-md medium color-gray-600'>
                                        +38 (097) 938-11-62
                                    </div>
                                </a>
                                <a href='mailto:info@ottry.com'>
                                    <div className='margin-top-0dot5rem mw768-margin-top-0 text-md medium color-gray-600'>
                                        info@ottry.com
                                    </div>
                                </a>
                            </div>
                            <div className='margin-top-2rem mw768-margin-top-0'>
                                <div className='display-flex mw768-justify-content-flex-end'>
                                    {/*<img className='height-1dot5rem mw768-height-3rem' src='https://wfp-help.s3.eu-central-1.amazonaws.com/1568625809_payment_methods_1.png%3Fversion%3D1%26amp%3BmodificationDate%3D1510658069000%26amp%3Bapi%3Dv2' alt=''/>*/}
                                    <IconMaster className='display-block margin-right-0dot5rem height-2rem mw768-height-2dot5rem'/>
                                    <IconVisa className='display-block margin-right-0dot5rem height-2rem mw768-height-2dot5rem'/>
                                    <IconApplePay className='display-block margin-right-0dot5rem height-2rem mw768-height-2dot5rem'/>
                                    <IconGooglePay className='display-block height-2rem mw768-height-2dot5rem'/>
                                </div>
                                <div className='hide-large padding-top-2rem'>
                                    <Feedback>
                                        <Button {...{color: 'primary-gradient', size: 'xl', fluid: 'always', clickHandler: () => {}}}>
                                            <FormattedMessage defaultMessage='Leave feedback'/>
                                        </Button>
                                    </Feedback>
                                </div>
                            </div>
                        </div>
                        <div className='display-flex flex-direction-column-row-reverse justify-content-space-between padding-top-2rem border-top-1px-solid border-color-gray-200'>
                            <div>
                                <div className='hide-large display-flex column-gap-0dot5rem text-sm medium padding-bottom-1rem'>
                                    <a
                                        className={classNames({'font-weight-bold color-gray-700': locale === 'uk'})}
                                        href={`${location.pathname}${getLocaleQueryParams(location.search, 'uk')}`}
                                    >
                                        <div className={classNames('color-gray-400', {'color-gray-700': locale === 'uk'})}>UA</div>
                                    </a>
                                    <a
                                        className={classNames({'font-weight-bold color-gray-700': locale === 'en'})}
                                        href={`${location.pathname}${getLocaleQueryParams(location.search, 'en')}`}
                                    >
                                        <div className={classNames('color-gray-400', {'color-gray-700': locale === 'en'})}>EN</div>
                                    </a>
                                </div>
                                <div className='display-flex flex-wrap-wrap column-gap-1rem'>
                                    <div>
                                        <Link className='text-md color-gray-400' to={`/rules${searchFilter(location.search)}`}><FormattedMessage defaultMessage='Rules'/></Link>
                                    </div>
                                    <div className=''>
                                        <Link className='text-md color-gray-400' to={`/terms${searchFilter(location.search)}`}><FormattedMessage defaultMessage='Terms of service'/></Link>
                                    </div>
                                    <div className=''>
                                        <Link className='text-md color-gray-400' to={`/privacy${searchFilter(location.search)}`}><FormattedMessage defaultMessage='Privacy policy'/></Link>
                                    </div>
                                    <div 
                                        className='cursor-pointer text-md color-gray-400'
                                        onClick={() => window?.CookieConsentApi?.showSettings()}
                                    >Cookies</div>
                                    <div className='hide-small display-flex column-gap-0dot5rem text-md medium padding-left-1rem'>
                                        <a
                                            className={classNames({'font-weight-bold color-gray-700': locale === 'uk'})}
                                            href={`${location.pathname}${getLocaleQueryParams(location.search, 'uk')}`}
                                        >
                                            <div className={classNames('color-gray-400', {'color-gray-700': locale === 'uk'})}>UA</div>
                                        </a>
                                        <a
                                            className={classNames({'font-weight-bold color-gray-700': locale === 'en'})}
                                            href={`${location.pathname}${getLocaleQueryParams(location.search, 'en')}`}
                                        >
                                            <div className={classNames('color-gray-400', {'color-gray-700': locale === 'en'})}>EN</div>
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className='margin-top-1rem mw768-margin-top-0 text-md color-gray-400'>
                                © {year} Ottry. All rights reserved.
                            </div>
                        </div>
                    </React.Suspense>
                </div>
            </div>
        </div>
    )
};

export default React.memo(Footer);